import { Row, Col, Typography } from 'antd';
import { TABLEAU_AUTHOR_DETAILS_LINK_URL } from '../../core/constants/global-constants';
import ArrowUpperRight from '../../assets/icons/arrow-up-right.svg';

const { Link } = Typography;

const OverlayTableauLink = ({ authorName }: { authorName?: string }) => {
  const href = authorName
    ? `${TABLEAU_AUTHOR_DETAILS_LINK_URL}?Author=${encodeURIComponent(authorName)}`
    : TABLEAU_AUTHOR_DETAILS_LINK_URL;

  return (
    <Row>
      <Col span={24} className='author-sales-col'>
        <Link
          href={href}
          target='_blank'
          rel='noopener noreferrer'
          className='author-sales-link'
        >
          See more author details on Tableau <img
            src={ArrowUpperRight}
            alt='Open in new tab'
            style={{ width: 16, height: 16, marginLeft: 4 }}
          />
        </Link>
      </Col>
    </Row>
  );
};

export default OverlayTableauLink;
